import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ApprovalData, ApprovalState, ApproverData, TypeOfApprovalAction } from "./approval.state";
import { RootState } from "../../../api/store";

const createInitialApproverForm = () => ({
    approver: null,
    notes: "",
    isOpen: false,
    typeOfAction: null,
});

const createInitialApprovalData = () => ({
    denied_notes: null,
    endorsed_by_name: null,
    endorsed_by_user_id: null,
    endorsed_to_name: null,
    endorsed_to_user_id: null,
    history: [],
    reviewed_at: null,
    reviewed_by_name: null,
    reviewed_by_user_id: null,
    special_actuarial_notes: null,
});

const initialState: ApprovalState = {
    approvalData: {
        denied_notes: null,
        endorsed_by_name: null,
        endorsed_by_user_id: null,
        endorsed_to_name: null,
        endorsed_to_user_id: null,
        history: [],
        reviewed_at: null,
        reviewed_by_name: null,
        reviewed_by_user_id: null,
        special_actuarial_notes: null,
    },
    approverForms: {
        approver: null,
        notes: '',
        isOpen: false,
        typeOfAction: null,
    },
    isOpenApprovalModal: false,
};

const approvalSlice = createSlice({
    name: "approvalSlice",
    initialState,
    reducers: {
        setApprovalData: (state, action: PayloadAction<ApprovalData>) => {
            state.approvalData = action.payload;
        },
        setApprover: (state, action: PayloadAction<ApproverData | null>) => {
            state.approverForms.approver = action.payload;
        },
        setApproverNotes: (state, action: PayloadAction<string>) => {
            state.approverForms.notes = action.payload;
        },
        setIsOpenApproverForm: (state, action: PayloadAction<boolean>) => {
            state.approverForms.isOpen = action.payload;
        },
        setTypeOfActionForApprover: (state, action: PayloadAction<TypeOfApprovalAction>) => {
            state.approverForms.typeOfAction = action.payload;
        },
        setIsOpenApproverModal: (state, action: PayloadAction<boolean>) => {
            state.isOpenApprovalModal = action.payload;
        },
        resetApproverForm: (state) => {
            state.approverForms = createInitialApproverForm();
        },
        resetApprovalState: (state) => {
            state.approvalData = createInitialApprovalData();
            state.approverForms = createInitialApproverForm();
            state.isOpenApprovalModal = false;
        },
    },
});

export const { 
    setApprovalData,
    setApprover,
    setApproverNotes,
    setIsOpenApproverModal,
    setIsOpenApproverForm,
    setTypeOfActionForApprover,
    resetApproverForm,

    resetApprovalState
} = approvalSlice.actions;

export const selectApprovalData = (state: RootState) => state.approvalSlice.approvalData;
export const selectApproverRates = (state: RootState) => state.approvalSlice.approverForms;
export const selectApproverFormRates = (state: RootState) => state.approvalSlice.approverForms.approver;
export const selectApprovalModalOpen = (state: RootState) => state.approvalSlice.isOpenApprovalModal;

export default approvalSlice.reducer;
